function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.985 10.475a1.344 1.344 0 0 0 1.626-.212l.748-.749h.001a2.116 2.116 0 0 1 2.997 0l2.022 2.023v-.001a2.12 2.12 0 0 1 0 2.997 4.96 4.96 0 0 1-5.702.96 20.7 20.7 0 0 1-5.36-3.809 20.7 20.7 0 0 1-3.81-5.361 4.955 4.955 0 0 1 .96-5.702 2.12 2.12 0 0 1 2.997 0l2.022 2.022c.828.828.828 2.17 0 2.997l-.748.749c-1.316 1.4 1.111 3.39 2.248 4.086m1.2-3.081a.579.579 0 0 0 0-1.156.579.579 0 0 0 0 1.156m5.354-.578A5.36 5.36 0 0 0 9.184 1.46a.578.578 0 0 0 0 1.156 4.2 4.2 0 0 1 4.199 4.199.578.578 0 0 0 1.156 0m-2.388 0a2.97 2.97 0 0 0-2.967-2.967.578.578 0 0 0 0 1.157c1 .001 1.81.81 1.81 1.81a.579.579 0 0 0 1.157 0",
    fill: "#fff",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhone);
export default __webpack_public_path__ + "static/media/ic_phone.3acfc807391f3c4a161c5f178bf7eb12.svg";
export { ForwardRef as ReactComponent };